import NotFound from 'src/NotFound';
import Layout from 'src/Layout';
import {
  ErrorPages,
  LayoutServiceData,
  SiteInfo,
  DictionaryPhrases,
  SitecoreContext,
} from '@sitecore-jss/sitecore-jss-nextjs';
import { SitecorePageProps } from 'lib/page-props';
import { useEffect, useState } from 'react';
import { LayoutServiceDataExtensions } from 'src/shared/shared.types';
import { componentBuilder } from 'temp/componentBuilder';

const Custom404 = ({ notFound, componentProps }: SitecorePageProps): JSX.Element => {
  const [pagelayoutData, setLayoutData] = useState<SitecorePageProps>();
  const [fetchError, setFetchError] = useState(false);

  useEffect(() => {
    if (!pagelayoutData) {
      fetch('/api/error/content')
        .then(async (res) => {
          const data = (await res.json()) as ErrorPages | null;
          if (data?.notFoundPage.rendered) {
            const matchedSite = data?.notFoundPage?.rendered?.sitecore?.context?.site as SiteInfo;
            setLayoutData({
              site: matchedSite,
              locale: matchedSite.language,
              dictionary: {} as DictionaryPhrases,
              componentProps: componentProps,
              notFound: notFound,
              layoutData: data?.notFoundPage.rendered as LayoutServiceData & {
                sitecore: LayoutServiceDataExtensions;
              },
              headLinks: [],
            });
          } else {
            setFetchError(true);
          }
        })
        .catch(() => {
          setFetchError(true);
        });
    }
  }, []);

  if (fetchError) {
    return <NotFound />;
  }

  if (!pagelayoutData?.layoutData) {
    return <></>;
  }

  return (
    <SitecoreContext
      componentFactory={componentBuilder.getComponentFactory()}
      layoutData={pagelayoutData?.layoutData}
    >
      <Layout layoutData={pagelayoutData?.layoutData} headLinks={pagelayoutData?.headLinks} />
    </SitecoreContext>
  );
};

export default Custom404;
